import { Component, Input, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TmModalComponent } from '../tm-modal/tm-modal.component';
import { TmModalData } from '../../entity/TmModalData';
import { Observable, throwError } from 'rxjs';
import { TmModalCloseReason } from '../../entity/TmModalCloseReason';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'tm-info-confirm',
  templateUrl: './info-confirm.component.html',
  styleUrls: ['./info-confirm.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class InfoConfirmComponent {
  @ViewChild(TmModalComponent, { static: true }) modal?: TmModalComponent;
  /** 表頭標題，預設為"INFO Confirm" */
  @Input() title = 'INFO Confirm';
  /** 主內文，可以塞入 HTML 標記語法 */
  private _message? = '';
  /** 主內文 */
  safeMessage?: SafeHtml;
  /** 主內文，可以塞入 HTML 標記語法 */
  @Input() set message(s: string) {
    if (s) {
      this._message = s;
      this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
    } else if (this._message) {
      delete this._message;
      delete this.safeMessage;
    }
  };
  /** 主內文，可以塞入 HTML 標記語法 */
  get message () { return this._message || ''; }
  /** 確認按鈕標籤，預設為"確認" */
  @Input() okBtnLabel = '確認';
  /** 取消按鈕標籤，預設為"取消" */
  @Input() cancelBtnLabel = '取消';
  /** 自訂義彈窗的 css 類，預設為"info-confirm-modal" */
  @Input() panelClass: string[] = ['info-confirm-modal'];
  /** 彈窗設定
   * https://v12.material.angular.io/components/dialog/api#MatDialogConfig
   */
  @Input() modalConfig?: MatDialogConfig<TmModalData>;
  /** 確認後關閉事件完成 */
  @Output() afterConfirm: EventEmitter<void> = new EventEmitter<void>();
  /** 非確認關閉事件完成 */
  @Output() afterCancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public dialog: MatDialog,
    protected sanitizer: DomSanitizer,
  ) { }

  open(): Observable<void> {
    if (!this.modal) { return throwError('Modal not ready'); }
    if (this.modal.isOpened) {
      console.error('Coding error! Already opened, You should manually close opened dialog, or use ReusableInfoConfirmComponent');
    }
    return this.modal.open();
  }
  
  close(): Observable<TmModalCloseReason|undefined> {
    if (!this.modal) { return throwError('Modal not ready'); }
    return this.modal.close();
  }
}
